import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { userStateBaseGuard } from './user-state-base.guard';

export const FTPAdminRequiredGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return userStateBaseGuard()?.allowFTPSearch;
}